/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, finalize, last, map, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NgxSpinnerService } from 'ngx-spinner';
import { NzModalService } from 'ng-zorro-antd/modal';
import { saveAs } from 'file-saver';

import { HttpUtils } from '../../../core/class';
import { UserRole } from '../../../core/enum';
import { AppOptionsService, AuthService, ErrorsHandlingService } from '../../../core/services';
import { CompanyInterface, PartnerInterfaceGlobal, PlatformInterface, SelectItemsInterface } from '../../../core/models';
import {
  AppMainActivityOptions,
  AppOptions,
  HelpersInterface,
  ListTypeApiEndpointsMain,
  ListTypeMain,
  ListTypeParamMain
} from '../../../core/interfaces';

import { MainDashboardInterface } from '../models';
import { CreateDspDialogComponent, CreateSspDialogComponent } from '../modals';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  public options: AppOptions;
  public userRole: UserRole;
  public supply: boolean;
  public demand: boolean;
  public sspSwitchButton = 'Endpoints';
  public dspSwitchButton = 'Endpoints';
  public optionsActivity: AppMainActivityOptions;
  public isDisabledSSPButtonDownload = false;
  public isDisabledDSPButtonDownload = false;
  public dspFilter = '';
  public isSorting = false;

  public dsps: CompanyInterface.ICompany[];
  public ssps: CompanyInterface.ICompany[];
  public allCompanies: CompanyInterface.ICompany[] = [];
  public sspFilters: MainDashboardInterface.IMainDashboardFilterModel[] = [];
  public dspFilters: MainDashboardInterface.IMainDashboardFilterModel[] = [];
  public dataDSPCompanies: MainDashboardInterface.ICompaniesDataForMainTable[] = [];
  public dataSSPCompanies: MainDashboardInterface.ICompaniesDataForMainTable[] = [];
  public dataSSPEndpoints: MainDashboardInterface.IEndpointsDataForMainTable[] = [];
  public dataDSPEndpoints: MainDashboardInterface.IEndpointsDataForMainTable[] = [];
  public filterLists: HelpersInterface.IFilterListsItems[] = [];
  public regions: { id: string, name: string }[] = [];
  public statesList: HelpersInterface.SelectItemHelper<string, string>[] = [];

  public osList: { id: string | number, name: string }[] = [];
  public rtbVersions: { id: string; name: string }[] = [];
  public schaninNodeLimitItems: { id: number; name: string }[] = [];

  public partnerSettings: PartnerInterfaceGlobal.IPartnerSettings | PartnerInterfaceGlobal.IPartnerGeneral;

  public paginationState: Partial<{
    ssp: {
      current_page: number;
      per_page: number;
      total: number;
    };
    dsp: {
      current_page: number;
      per_page: number;
      total: number;
    };
  }> = {
      ssp: {
        current_page: 1,
        per_page: 25,
        total: 100,
      },
      dsp: {
        current_page: 1,
        per_page: 25,
        total: 100,
      }
    };

  public selectedFilter: any = {
    dsp: null,
    ssp: null,
  };
  public openedFilter: { ssp: false, dsp: false } = {
    dsp: false,
    ssp: false,
  };

  public ad_formats_dsp = [
    { id: '-1', name: 'All Ad formats' },
    { id: 'banner', name: 'Banner' },
    { id: 'native', name: 'Native' },
    { id: 'video', name: 'Video' },
    { id: 'audio', name: 'Audio' }
  ];

  public ad_formats = [
    { id: '-1', name: 'All Ad formats' },
    { id: 'isBanner', name: 'Banner' },
    { id: 'isNative', name: 'Native' },
    { id: 'isVideo', name: 'Video' },
    { id: 'audio', name: 'Audio' }
  ];

  public nurlOptions: { id: number, name: string }[] = [];

  public set sspSpinnerStatus(value: boolean) {
    this._sspSpinnerStatus = value;
  }

  public get sspSpinnerStatus(): boolean {
    return this._sspSpinnerStatus;
  }

  public set dspSpinnerStatus(value: boolean) {
    this._dspSpinnerStatus = value;
  }

  public get dspSpinnerStatus(): boolean {
    return this._dspSpinnerStatus;
  }

  private listOfSizes: { id: number, width: number | null, height: number | null, name: string }[] = [];
  private pornFilter: { id: number, name: string }[] = [];
  private sizesList: { id: string | number, name: string }[] = [];
  private secureOptions: { id: number, name: string }[] = [];
  private connectionTypes: { id: number; name: string }[] = [];

  private countriesItems: SelectItemsInterface.ICountriesItem[] = [];

  private sspList: PlatformInterface.ISSPList[] = [];

  private filterData = {
    ssp: {
      activity: '1',
      currentPage: 1,
      trashed: 0,
      filters: {
        ad_format: [],
        region: [],
        integration_type: [],
        traffic_type: [],
      },
      search: '',
      sortBy: 'name',
      sortOrder: 'desc',
    },
    dsp: {
      activity: '1',
      currentPage: 1,
      trashed: 0,
      filters: {
        ad_format: [],
        region: [],
        integration_type: [],
        traffic_type: [],
      },
      search: '',
      sortBy: 'name',
      sortOrder: 'desc',
    },
  };

  private filters: { dsp: object, ssp: object } = {
    dsp: {
      ad_format: [],
      region: [],
      integration_type: [],
      traffic_type: [],
    },
    ssp: {
      ad_format: [],
      region: [],
      integration_type: [],
      traffic_type: [],
    },
  };

  private _sspSpinnerStatus = true;
  private _dspSpinnerStatus = true;



  private apiUrl = '';
  constructor(
    private http: HttpClient,
    private appOptionsService: AppOptionsService,
    private errorsHandlingService: ErrorsHandlingService,
    private authService: AuthService,
    private loadingService: NgxSpinnerService,
    private modalService: NzModalService,
  ) {
    this.apiUrl = this.appOptionsService.getApiUrl();
    this.userRole = this.authService.userRole;
  }
  public initComponent(): void {
    this.setTableOptions();
    this.setFilterInitWhileInit();
    this.onSetSupplyAndDemand();
    this.getPartnerInfo();
    this.getFilters();
    this.getFilterItems();
    this.getEndpoints();
    this.getCompanyList();
    this.getRegions();
  }

  public get isDisable(): boolean {
    return this.filterLists.length === 0;
  }

  public onLoadSSPTableData(callback: () => void): void {
    if (!this.supply) {
      this.sspSwitchButton = 'Endpoints';
      this.getCompaniesForSSPTable(callback);
    } else {
      this.sspSwitchButton = 'Companies';
      this.getEndpointsForSSPTable(callback);
    }
  }

  public onLoadDSPTableData(callback: () => void): void {
    if (!this.demand) {
      this.dspSwitchButton = 'Endpoints';
      this.getCompaniesForDSPTable(callback);
    } else {
      this.dspSwitchButton = 'Companies';
      this.getEndpointsForDSPTable(callback);
    }
  }

  public onCreateSSPHandler(modalHeight: string, modalBodyHeight: string, callback: () => void): void {
    const dialogRef = this.modalService.create({
      nzContent: CreateSspDialogComponent,
      nzMaskClosable: false,
      nzClassName: 'endpoint-create-modal',
      nzWrapClassName: 'endpoint-create-modal-wrap',
      nzStyle: { top: '0px', width: '100%', height: modalHeight, overflow: 'hidden', maxWidth: 'none' },
      nzBodyStyle: { width: '100%', height: modalBodyHeight, overflowY: 'scroll', overflowX: 'hidden', padding: '0' },
      nzData: {
        allCompanies: this.allCompanies,
        partnerSettings: this.partnerSettings as any,
      }
    });
    dialogRef.afterClose.subscribe(data => {
      if (data === 'created') {
        this.getCompanyList();
        switch (this.supply) {
          case true:
            this.getEndpointsForSSPTable(callback);
            break;
          case false:
            this.getCompaniesForSSPTable(callback);
            break;
        }
      }
    });
  }

  public onCreateDSPHandler(modalHeight: string, modalBodyHeight: string, callback: () => void): void {
    if (Object.keys(this.partnerSettings).length > 0) {
      const dialogRef = this.modalService.create({
        nzContent: CreateDspDialogComponent,
        nzMaskClosable: false,
        nzClassName: 'endpoint-create-modal',
        nzWrapClassName: 'endpoint-create-modal-wrap',
        nzStyle: { top: '0px', width: '100%', height: modalHeight, overflow: 'hidden', maxWidth: 'none' },
        nzBodyStyle: { width: '100%', height: modalBodyHeight, overflowY: 'scroll', overflowX: 'hidden', padding: '0' },
        nzData: {
          allCompanies: this.allCompanies,
          connectionTypes: this.connectionTypes,
          partnerSettings: this.partnerSettings as any,
          sspList: this.sspList,
          osList: this.osList,
          sizesList: this.sizesList,
          pornFilter: this.pornFilter,
          secureOptions: this.secureOptions,
          countriesItems: this.countriesItems,
          nurlOptions: this.nurlOptions,
          listOfSizes: this.listOfSizes,
          rtbVersions: this.rtbVersions,
          schaninNodeLimitItems: this.schaninNodeLimitItems,
          statesList: this.statesList,
        }
      });
      dialogRef.afterClose.subscribe(data => {
        if (data === 'created') {
          this.getCompanyList();
          switch (this.demand) {
            case true:
              this.getEndpointsForDSPTable(callback);
              break;
            case false:
              this.getCompaniesForDSPTable(callback);
              break;
          }
        }
      });
    }
  }

  public onChangePageHandler(data: { current_page: number; type: string; }, side: string, callback: () => void): void {
    this.paginationState[side].current_page = data.current_page;
    this.filterData[side].currentPage = data.current_page;
    if (side === 'ssp')
      switch (data.type) {
        case 'endpoints':
          this.getEndpointsForSSPTable(callback);
          break;
        case 'companies':
          this.getCompaniesForSSPTable(callback);
          break;
      } else {
      switch (data.type) {
        case 'endpoints':
          this.getEndpointsForDSPTable(callback);
          break;
        case 'companies':
          this.getCompaniesForDSPTable(callback);
          break;
      }
    }
  }

  public onUpdateEndpointActiveStatusHandler(emittedData: { side: string; type: string }, callback: () => void): void {
    if (emittedData.side === 'ssp')
      switch (emittedData.type) {
        case 'endpoints':
          this.getEndpointsForSSPTable(callback);
          break;
        case 'companies':
          this.getCompaniesForSSPTable(callback);
          break;
      } else {
      switch (emittedData.type) {
        case 'endpoints':
          this.getEndpointsForDSPTable(callback);
          break;
        case 'companies':
          this.getCompaniesForDSPTable(callback);
          break;
      }
    }
  }

  public onActivateCompanyHandler(event: { side: string }, callback: () => void): void {
    switch (event.side) {
      case 'ssp':
        this.getCompaniesForSSPTable(callback);
        break;
      case 'dsp':
        this.getCompaniesForDSPTable(callback);
        break;
    }
  }

  public onOptionChanged(e: { attr: string, label: string, active: boolean }[], type: string) {
    this.appOptionsService.setOption(e, type);
  }

  public onOptionMainActivityChangeHandler(value: string, side: string, callback: () => void) {
    this.appOptionsService.setOptionsMainActivity(this.optionsActivity[side], side);
    this.filterData[side].trashed = value === '2' ? '1' : '0';
    this.filterData[side].activity = value === '2' ? '-1' : value;
    this.filterData[side].currentPage = 1;
    if (side === 'ssp') {
      switch (this.supply) {
        case true:
          this.getEndpointsForSSPTable(callback);
          break;
        case false:
          this.getCompaniesForSSPTable(callback);
          break;
      }
    } else {
      switch (this.demand) {
        case true:
          this.getEndpointsForDSPTable(callback);
          break;
        case false:
          this.getCompaniesForDSPTable(callback);
          break;
      }
    }
  }

  public onFilterHandler(value: {
    ad_format: string[],
    region: string[],
    integration_type: number[],
    traffic_type: string[],
  }, side: string, callback: () => void): void {
    this.filters[side] = value;
    this.filterData[side].filters = { ...this.filters[side] };
    if (side === 'ssp') {
      switch (this.supply) {
        case true:
          this.getEndpointsForSSPTable(callback);
          break;
        case false:
          this.getCompaniesForSSPTable(callback);
          break;
      }
    } else {
      switch (this.demand) {
        case true:
          this.getEndpointsForDSPTable(callback);
          break;
        case false:
          this.getCompaniesForDSPTable(callback);
          break;
      }
    }
  }

  public onUpdateSSPHandler(status: string, callback: () => void): void {
    switch (status) {
      case 'updated':
        switch (this.supply) {
          case true:
            this.getEndpointsForSSPTable(callback);
            break;
          case false:
            this.getCompaniesForSSPTable(callback);
            break;
        }
        break;
    }
  }

  public onUpdateDSPHandler(status: string, callback: () => void): void {
    switch (status) {
      case 'updated':
        switch (this.demand) {
          case true:
            this.getEndpointsForDSPTable(callback);
            break;
          case false:
            this.getCompaniesForDSPTable(callback);
            break;
        }
    }
  }

  public onSearchChangeHandler(name: string, side: string, callback: () => void) {
    this.filterData[side].search = name;
    this.filterData[side].currentPage = 1;
    if (side === 'ssp') {
      switch (this.supply) {
        case true:
          this.getEndpointsForSSPTable(callback);
          break;
        case false:
          this.getCompaniesForSSPTable(callback);
          break;
      }
    } else {
      switch (this.demand) {
        case true:
          this.getEndpointsForDSPTable(callback);
          break;
        case false:
          this.getCompaniesForDSPTable(callback);
          break;
      }
    }
  }

  public onSortTableHandler(sortState: { sortBy: string; sortOrder: string; }, side: string, callback: () => void) {
    this.filterData[side].sortBy = sortState.sortBy;
    this.filterData[side].sortOrder = sortState.sortOrder;
    if (side === 'ssp') {
      switch (this.supply) {
        case true:
          this.getEndpointsForSSPTable(callback);
          break;
        case false:
          this.getCompaniesForSSPTable(callback);
          break;
      }
    } else {
      switch (this.demand) {
        case true:
          this.getEndpointsForDSPTable(callback);
          break;
        case false:
          this.getCompaniesForDSPTable(callback);
          break;
      }
    }
  }

  public onChangeTableViewHandler(side: string, toggleView: string, callback: () => void) {
    if (side === 'ssp') {
      this.sspSwitchButton = toggleView;
      this.filterData.ssp.currentPage = 1;
      switch (toggleView) {
        case 'Companies':
          this.getCompaniesForSSPTable(callback);
          this.supply = false;
          break;
        case 'Endpoints':
          this.getEndpointsForSSPTable(callback);
          this.supply = true;
          break;
      }
    } else {
      this.dspSwitchButton = toggleView;
      this.filterData.dsp.currentPage = 1;
      switch (toggleView) {
        case 'Companies':
          this.getCompaniesForDSPTable(callback);
          this.demand = false;
          break;
        case 'Endpoints':
          this.getEndpointsForDSPTable(callback);
          this.demand = true;
          break;
      }
    }

    this.authService.mainSspDspTableOpened = { supply: this.supply, demand: this.demand };
  }

  public onDownloadInfoHandler(side: string) {
    const data = {
      ssp: {
        activity: this.filterData.ssp.activity,
        filters: this.filterData.ssp.filters,
        search: this.filterData.ssp.search,
        sortBy: this.filterData.ssp.sortBy,
        sortOrder: this.filterData.ssp.sortOrder,
      },
      dsp: {
        activity: this.filterData.dsp.activity,
        filters: this.filterData.dsp.filters,
        search: this.filterData.dsp.search,
        sortBy: this.filterData.dsp.sortBy,
        sortOrder: this.filterData.dsp.sortOrder,
      }
    };

    this.downloadMainInfoReq(side, data[side])
      .subscribe(
        resp => saveAs(resp.body, 'main-info-' + side + '.csv'),
        () => this.errorsHandlingService.showNotification('error', 'Empty endpoints list', 'error', 'error', null)
      );
  }

  public onDeleteEndpointSSPHandler(data: { endpointId: number, side: string; companyId?: number }, callback: () => void): void {
    this.loadingService.show('ssp');
    this.deleteEndpointReq(data.endpointId, data.side)
      .pipe(finalize(() => this.loadingService.hide('ssp')))
      .subscribe(() => {
        this.errorsHandlingService.showNotification('success', 'Endpoint deleted', 'success', 'success', null);
        switch (this.supply) {
          case true:
            this.dataSSPEndpoints = [];
            this.getEndpointsForSSPTable(callback);
            break;
          case false:
            this.dataSSPCompanies = [];
            this.getCompaniesForSSPTable(callback);
            break;
        }
      },
        error => this.errorsHandlingService.handleError(error));
  }

  public onDuplicateEndpointSSPHandler(data: { endpointId: number, side: string }, callback: () => void): void {
    this.loadingService.show('ssp');
    this.duplicateEndpointReq(data.endpointId, data.side)
      .pipe(finalize(() => this.loadingService.hide('ssp')))
      .subscribe(() => {
        this.errorsHandlingService.showNotification('success', 'Endpoint is duplicated!', 'success', 'success', null);
        switch (this.supply) {
          case true:
            this.dataSSPEndpoints = [];
            this.getEndpointsForSSPTable(callback);
            break;
          case false:
            this.dataSSPCompanies = [];
            this.getCompaniesForSSPTable(callback);
            break;
        }
      }, err => {
        this.errorsHandlingService.handleError(err);
      });
  }

  public onDeleteEndpointDSPHandler(data: { endpointId: number, side: string; companyId?: number }, callback: () => void): void {
    this.loadingService.show('dsp');
    this.deleteEndpointReq(data.endpointId, data.side)
      .pipe(finalize(() => this.loadingService.hide('dsp')))
      .subscribe(() => {
        this.errorsHandlingService.showNotification('success', 'Endpoint deleted!', 'success', 'success', null);
        switch (this.demand) {
          case true:
            this.dataDSPEndpoints = [];
            this.getEndpointsForDSPTable(callback);
            break;
          case false:
            this.dataDSPCompanies = [];
            this.getCompaniesForDSPTable(callback);
            break;
        }
      },
        error => this.errorsHandlingService.handleError(error));
  }

  public onDuplicateEndpointDSPHandler(data: { endpointId: number, side: string }, callback: () => void): void {
    this.loadingService.show('dsp');
    this.duplicateEndpointReq(data.endpointId, data.side)
      .pipe(finalize(() => this.loadingService.hide('dsp')))
      .subscribe(() => {
        this.errorsHandlingService.showNotification('success', 'Endpoint is duplicated!', 'success', 'success', null);
        switch (this.demand) {
          case true:
            this.getEndpointsForDSPTable(callback);
            break;
          case false:
            this.getCompaniesForDSPTable(callback);
            break;
        }
      }, err => {
        this.errorsHandlingService.handleError(err);
      });
  }

  public toggleEndpointsStatus(id: number, active: number, endpointsType: string): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/company/${id}`,
      JSON.stringify({ active, endpointsType }),
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      },
    )
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public updateEndpointById(id: number, data: any, side: string): Observable<any> {
    return this.http.patch(
      `${this.apiUrl}/${side}/${id}`,
      JSON.stringify(data),
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      },
    )
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public testApiLink(link: string): Promise<MainDashboardInterface.IApiLinkTestResponse> {
    return new Promise((resolve) => {
      this.http.post(`${this.apiUrl}/company/apilinktest`, { link: link })
        .pipe(catchError(this.errorsHandlingService.processError))
        .subscribe(
          (resp: any) => {
            resolve(resp);
          },
          error => this.errorsHandlingService.handleError(error)
        );
    });
  }

  public getAllCompaniesByConnectionType(filter: { connectionType: number, settings: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/company/connection-type`, filter)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getAdaptersByType(filter: { is_prebid: boolean, type: string }): Observable<PlatformInterface.IPreBidItem[]> {
    return this.http.post<PlatformInterface.IPreBidItem[]>(`${this.apiUrl}/adapters`, filter)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getAdServers(): Observable<any> {
    return this.http.post(`${this.apiUrl}/ad-servers`, null, { headers: new HttpHeaders().set('Content-Type', 'application/json') })
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public createNewDSP(data: {
    [key: string]: any;
  }): Observable<PlatformInterface.IUpdateDSPResponse> {
    return this.http.post<PlatformInterface.IUpdateDSPResponse>(`${this.apiUrl}/dsp`, JSON.stringify(data),
      { headers: new HttpHeaders().set('Content-Type', 'application/json') },
    )
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public createNewSSP(data: any): Observable<PlatformInterface.IUpdateSSPResponse> {
    const post = { ...data };

    return this.http.post<PlatformInterface.IUpdateSSPResponse>(
      `${this.apiUrl}/ssp`,
      JSON.stringify(post),
      { headers: new HttpHeaders().set('Content-Type', 'application/json') },
    )
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getCompaniesNames(filter = null): Observable<CompanyInterface.ICompanyListResponse> {
    const requestParams = HttpUtils.getRequestParams({ ...filter as unknown as object });

    return this.http.get<CompanyInterface.ICompanyListResponse>(`${this.apiUrl}/company/names`, { params: requestParams })
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getSeatAndTokenForSspEndpoint(): Observable<any> {
    return this.http.post(`${this.apiUrl}/ssp/endpoint/seat-and-token`, null,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') },
    ).pipe(catchError(this.errorsHandlingService.processError));
  }

  public getDSP(id: number): Observable<PlatformInterface.IResponseDSPById> {
    return this.http.get<PlatformInterface.IResponseDSPById>(`${this.apiUrl}/dsp/${id}`)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getSSP(id: number): Observable<PlatformInterface.IResponseSSPById> {
    return this.http.get<PlatformInterface.IResponseSSPById>(`${this.apiUrl}/ssp/${id}`)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public saveSSPCookieSync(cookieSync: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/cookie-sync`, cookieSync,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') })
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getBidExample(side: string, type: string, id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${side}/${id}/${type}/example`).pipe(catchError(this.errorsHandlingService.processError));
  }

  public parseFile(file: File, listType = 'sites'): Observable<{
    count: number;
    items: string[];
    status: string;
  }> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<{
      count: number;
      items: string[];
      status: string;
    }>(`${this.apiUrl}/parse/type/${listType}`, formData, {
      reportProgress: true,
    })
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public setList(endpointType: string, endpointId: string, listType: string, list: Array<string>): Observable<{
    data: { allowedPublishersCount: number }
    status: string;
  }> {

    const byListTypeApiEndpoints: ListTypeApiEndpointsMain = {
      'ssp': {
        'blocked-crids': 'crid/blocked',
        'blocked-domains': 'domains/blocked',
      },
      'dsp': {
        'bundles': 'bundles/allowed',
        'sites': 'sites/allowed',
        'publishers': 'publishers/allowed',
        'blocked-publishers': 'publishers/blocked',
        'blocked-bundles': 'bundles/blocked',
        'blocked-sites': 'sites/blocked',
        'blocked-ips': 'ips/blocked',
      },
    };
    const byListTypeParam: ListTypeParamMain = {
      'ssp': {
        'blocked-crids': 'blockedCrids',
        'blocked-domains': 'blockedDomains',
      },
      'dsp': {
        'bundles': 'allowedBundles',
        'sites': 'allowedSites',
        'publishers': 'allowedPublishers',
        'blocked-publishers': 'blockedPublishers',
        'blocked-bundles': 'blockedBundles',
        'blocked-sites': 'blockedSites',
        'blocked-ips': 'blockedIps',
      },
    };


    const apiEnd = byListTypeApiEndpoints[endpointType][listType];

    const param = byListTypeParam[endpointType][listType];
    const data = {};
    data[param] = list.filter(i => i.toString().trim().length > 0);

    return this.http.post<{
      data: { allowedPublishersCount: number }
      status: string;
    }>(`${this.apiUrl}/${endpointType}/${endpointId}/${apiEnd}`, data)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public downLoadList(endpointType: string, endpointId: string, listType: string): Observable<Blob> {
    const byListTypeApiEndpoints: ListTypeApiEndpointsMain = {
      'ssp': {
        'blocked-crids': 'crid/blocked',
        'blocked-domains': 'domains/blocked',
      },
      'dsp': {
        'bundles': 'bundles/allowed',
        'sites': 'sites/allowed',
        'publishers': 'publishers/allowed',
        'blocked-publishers': 'publishers/blocked',
        'blocked-bundles': 'bundles/blocked',
        'blocked-sites': 'sites/blocked',
        'blocked-ips': 'ips/blocked',

      },
    };

    const apiEnd = byListTypeApiEndpoints[endpointType as keyof ListTypeApiEndpointsMain][listType as keyof ListTypeMain];
    return this.http.get(`${this.apiUrl}/${endpointType}/${endpointId}/${apiEnd}/download`, { responseType: 'blob' })
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public deleteFilterList(endpointType: any, endpointId: any, listType: any): Observable<{ status: string }> {
    return this.http.delete<{ status: string }>(`${this.apiUrl}/${endpointType}/${endpointId}/${listType}`)
      .pipe(catchError(this.errorsHandlingService.processError));
  }


  public onValidateEndpointRegion(reqBody: { endpoint: string; region: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/dsp/endpoint/test/region`, reqBody)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public onValidateEndpointUrl(reqBody: { endpoint: string; region: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/dsp/endpoint/test/url`, reqBody)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public onValidateEndpointIp(reqBody: { endpoint: string; region: string }): Observable<any> {
    return this.http.post(`${this.apiUrl}/dsp/endpoint/test/ip`, reqBody)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  private getFilterItems(): void {
    this.getFilterValuesByKeyReq({ filters: ['schainLimitFilter', 'os', 'filterLists', 'rtbTypes', 'statesFilter'] })
      .subscribe((res:
        {
          schainLimitFilter: { id: number; name: string }[];
          os: { id: number; name: string }[];
          filterLists: HelpersInterface.IFilterListsItems[];
          rtbTypes: string[];
          statesFilter: HelpersInterface.SelectItemHelper<string, string>[]
        }
      ) => {
        this.schaninNodeLimitItems = res.schainLimitFilter;
        this.osList = res.os;
        this.filterLists = res.filterLists;
        this.rtbVersions = res.rtbTypes.map(type => {
          return { id: type, name: type };
        });

        this.statesList = res.statesFilter;
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getRegions(): void {
    this.getFilterValuesByKeyReq({ filters: ['regions'] })
      .subscribe(res => {
        this.regions = res.regions.map(region => {
          return { id: region, name: region };
        });
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getEndpoints(): void {
    this.getEndpointItemsReq()
      .subscribe(data => {
        this.sspList = data.ssp;
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getCompanyList(): void {
    this.getCompanyItemsReq()
      .subscribe(resp => {
        this.allCompanies = resp.data;
        this.allCompanies.unshift({
          id: -1,
          name: '+ Create New Company',
          terms: 30
        });
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getFilters(): void {
    this.getDashboardFiltersReq()
      .subscribe(res => {
        this.sspFilters = this.getModifiedFilters(res.data.ssp);
        this.dspFilters = this.getModifiedFilters(res.data.dsp);
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getPartnerInfo(): void {
    this.authService.getAllPartnerInfo()
      .subscribe(res => {
        this.partnerSettings = res.data as any;
        if (this.partnerSettings.partner_plan === 3) {
          this.getUpdatedFilters(this.sspFilters, [4, 5], ['APAC', 'EU']);
          this.getUpdatedFilters(this.dspFilters, [4], ['APAC', 'EU']);
        }
        this.authService.partner = res.data;

        if ((this.partnerSettings as PartnerInterfaceGlobal.IPartnerSettings).hide_deleted_endpoints) {
          this.optionsActivity.ssp = this.optionsActivity.ssp.filter(item => item.id !== '2');
          this.optionsActivity.dsp = this.optionsActivity.dsp.filter(item => item.id !== '2');
        }
      },
        error => this.errorsHandlingService.handleError(error));
  }

  public onSetItemsHandler(): void {
    this.sizesList = this.appOptionsService.getSizesList();
    this.pornFilter = this.appOptionsService.getPornFilter();
    this.secureOptions = this.appOptionsService.getSecureOptions();
    this.countriesItems = this.appOptionsService.getCountriesItems();
    this.connectionTypes = this.appOptionsService.getConnectionTypes();
    this.nurlOptions = this.appOptionsService.getNurlOptions();
    this.listOfSizes = this.appOptionsService.getListOfSizes();
    this.appOptionsService.currentOptions
      .pipe(takeUntilDestroyed())
      .subscribe((options: AppOptions) => {
        this.options = Object.assign({}, options);
      });

    this.optionsActivity = this.appOptionsService.getOptionsMainActivity();
  }

  private getUpdatedFilters(filters: MainDashboardInterface.IMainDashboardFilterModel[], itemsIDs: number[], itemNames: string[]): MainDashboardInterface.IMainDashboardFilterModel[] {
    return filters.map(parentItem => {
      if (parentItem.name === 'integration_type') {
        parentItem.values = parentItem.values.map(item => {
          item.disabled = itemsIDs.includes(item.id as number);
          item.tooltip = item.disabled
            ? `${item.name} is available on Plus and Enterprise versions. If you want to upgrade your platform, please contact our Business Development Manager`
            : '';
          return item;
        });
      }
      if (parentItem.name === 'region') {
        parentItem.values = parentItem.values.map(item => {
          item.disabled = itemNames.includes(item.name);
          item.tooltip = item.disabled
            ? `${item.name} is available on Plus and Enterprise versions. If you want to upgrade your platform, please contact our Business Development Manager`
            : '';
          return item;
        });
      }

      return parentItem;
    });

  }

  private onSetSupplyAndDemand(): void {
    this.supply = this.authService.mainSspDspTableOpened.supply ?? true;
    this.demand = this.authService.mainSspDspTableOpened.demand ?? true;
  }

  private getCompaniesForSSPTable(callback: () => void): void {
    this.dataSSPCompanies = [];
    this.loadingService.show('ssp');
    this.sspSpinnerStatus = true;
    this.getCompaniesWithSummaryReq('ssp', this.filterData.ssp)
      .pipe(finalize(() => this.loadingService.hide('ssp')))
      .subscribe(res => {
        this.dataSSPCompanies = res.data;
        this.paginationState.ssp.current_page = res.current_page;
        this.paginationState.ssp.per_page = res.per_page;
        this.paginationState.ssp.total = res.total;
        this.isDisabledSSPButtonDownload = res.total === 0 ? true : false;
        this.sspSpinnerStatus = false;
        callback();
      },
        error => {
          this.sspSpinnerStatus = false;
          this.errorsHandlingService.handleError(error);
        });
  }

  private getCompaniesForDSPTable(callback: () => void): void {
    this.dataDSPCompanies = [];
    this.loadingService.show('dsp');
    this.dspSpinnerStatus = true;
    this.getCompaniesWithSummaryReq('dsp', this.filterData.dsp)
      .pipe(finalize(() => this.loadingService.hide('dsp')))
      .subscribe(res => {
        this.dataDSPCompanies = res.data;
        this.paginationState.dsp.current_page = res.current_page;
        this.paginationState.dsp.per_page = res.per_page;
        this.paginationState.dsp.total = res.total;
        this.isDisabledDSPButtonDownload = res.total === 0 ? true : false;
        this.dspSpinnerStatus = false;
        callback();
      },
        error => {
          this.dspSpinnerStatus = false;
          this.errorsHandlingService.handleError(error);
        });
  }

  private getEndpointsForSSPTable(callback: () => void): void {
    const data = {
      search: this.filterData.ssp.search,
      sortBy: this.filterData.ssp.sortBy,
      sortOrder: this.filterData.ssp.sortOrder,
      activity: this.filterData.ssp.activity,
      trashed: this.filterData.ssp.trashed,
      currentPage: this.filterData.ssp.currentPage,
      filters: this.filterData.ssp.filters,
    };
    this.dataSSPEndpoints = [];
    this.loadingService.show('ssp');
    this.sspSpinnerStatus = true;
    this.getEndpointsForCompanyReq('ssp', data)
      .pipe(finalize(() => this.loadingService.hide('ssp')))
      .subscribe(res => {
        this.dataSSPEndpoints = res.data;
        this.paginationState.ssp.current_page = res.current_page;
        this.paginationState.ssp.per_page = res.per_page;
        this.paginationState.ssp.total = res.total;
        this.isDisabledSSPButtonDownload = res.total === 0 ? true : false;
        this.sspSpinnerStatus = false;
        callback();
      },
        error => {
          this.sspSpinnerStatus = false;
          this.errorsHandlingService.handleError(error);
        });
  }

  private getEndpointsForDSPTable(callback: () => void): void {
    const data = {
      search: this.filterData.dsp.search,
      sortBy: this.filterData.dsp.sortBy,
      sortOrder: this.filterData.dsp.sortOrder,
      activity: this.filterData.dsp.activity,
      trashed: this.filterData.dsp.trashed,
      currentPage: this.filterData.dsp.currentPage,
      filters: this.filterData.dsp.filters,
    };
    this.dataDSPEndpoints = [];
    this.loadingService.show('dsp');
    this.dspSpinnerStatus = true;
    this.getEndpointsForCompanyReq('dsp', data)
      .pipe(finalize(() => this.loadingService.hide('dsp')))
      .subscribe(res => {
        this.dataDSPEndpoints = res.data;
        this.paginationState.dsp.current_page = res.current_page;
        this.paginationState.dsp.per_page = res.per_page;
        this.paginationState.dsp.total = res.total;
        this.isDisabledDSPButtonDownload = res.total === 0 ? true : false;
        this.dspSpinnerStatus = false;
        callback();
      },
        error => {
          this.dspSpinnerStatus = false;
          this.errorsHandlingService.handleError(error);
        });
  }

  private getModifiedFilters(filter: {
    active: boolean;
    forAll: string;
    label: string;
    name: string;
    filters: string[];
    values: any;
  }[]): MainDashboardInterface.IMainDashboardFilterModel[] {
    return filter.map(element => {
      element.filters = [];
      element.values = this.getModifiedFilterValues(element.values);
      return element;
    });
  }

  private getModifiedFilterValues(values: { [key: string]: string }): {
    id: string;
    name: string;
  }[] {
    return Object.entries(values).map((value) => {
      return { id: value[1], name: value[0] };
    });
  }


  private downloadMainInfoReq(side, filter): Observable<any> {
    const activeEndpoint = this.appOptionsService.getOptionsMainActivity();
    const activeOptions = this.appOptionsService.getOptions();
    const columns = [];

    for (let i = 0; i < activeOptions[side].length; i++) {
      if (activeOptions[side][i].active) {
        columns.push(activeOptions[side][i].attr);
      }
    }
    filter.columns = columns;

    return this.http.request(
      'POST',
      `${this.apiUrl}/company/download-info/${side}?activeEndpoint=${activeEndpoint[side + 'Selected']}`,
      {
        body: JSON.stringify(filter),
        reportProgress: true,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        },
        observe: 'response'
      }
    ).pipe(
      map(event => this.getDownloadEventMessage(event)),
      tap(message => {
        this.handleMessage(message);
      }),
      last(),
      catchError(this.errorsHandlingService.processError)
    );
  }

  public deleteEndpointReq(endpointId: any, type: any): Observable<any> {
    const url = `${this.apiUrl}/${type}/${endpointId}`;
    return this.http.delete(url)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public duplicateEndpointReq(id: any, side: any): Observable<any> {
    return this.http.get(`${this.apiUrl}/company/endpoint-duplicate/${id}/${side}`)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getEndpointItemsReq(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/endpoints`)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  private getCompanyItemsReq(searchValue: string | number = ''): Observable<CompanyInterface.ICompanyListResponse> {
    return this.http.post<CompanyInterface.ICompanyListResponse>(`${this.apiUrl}/company/get-all`, { search: searchValue })
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getDashboardFiltersReq(): Observable<MainDashboardInterface.IMainDashboardFilterResponse> {
    return this.http.get<MainDashboardInterface.IMainDashboardFilterResponse>(`${this.apiUrl}/dashboard`)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  private getCompaniesWithSummaryReq(side: string, filter: MainDashboardInterface.IReqDataForMainDashboardCompanies):
    Observable<MainDashboardInterface.IResponseForCompaniesMainTable> {
    return this.http.post<MainDashboardInterface.IResponseForCompaniesMainTable>(`${this.apiUrl}/company/summary-endpoints/${side}`, filter)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  private getEndpointsForCompanyReq(side: string, filter: MainDashboardInterface.IReqDataForMainDashboardEndpoints):
    Observable<MainDashboardInterface.IResponseForEndpointsMainTable> {
    return this.http.post<MainDashboardInterface.IResponseForEndpointsMainTable>(`${this.apiUrl}/company/endpoints/${side}`, filter)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  public getFilterValuesByKeyReq(filtersArray: { filters: string[] }): Observable<any> {
    return this.http.post(`${this.apiUrl}/filter_values`, filtersArray)
      .pipe(catchError(this.errorsHandlingService.processError));
  }

  private getDownloadEventMessage(event: HttpEvent<any>) {
    return event;
  }

  private bytesToSize(bytes: number): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
      return '0 Byte';
    }
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
  }

  private handleMessage(event: HttpEvent<any>) {
    switch (event.type) {
      case HttpEventType.Sent:
        this.errorsHandlingService.showNotification('info', 'info', 'info', 'Requesting data...', null);
        break;
      case HttpEventType.ResponseHeader:
        this.errorsHandlingService.showNotification('info', 'info', 'info', 'Requesting data...', null);
        break;
      case HttpEventType.DownloadProgress:
        this.errorsHandlingService.showNotification('info', 'info', 'info', `${this.bytesToSize(event.loaded)} downloaded`, null);
        break;
    }
    return event;
  }

  private setFilterInitWhileInit(): void {
    this.filterData = {
      ssp: {
        activity: '1',
        currentPage: 1,
        trashed: 0,
        filters: {
          ad_format: [],
          region: [],
          integration_type: [],
          traffic_type: [],
        },
        search: '',
        sortBy: 'name',
        sortOrder: 'desc',
      },
      dsp: {
        activity: '1',
        currentPage: 1,
        trashed: 0,
        filters: {
          ad_format: [],
          region: [],
          integration_type: [],
          traffic_type: [],
        },
        search: '',
        sortBy: 'name',
        sortOrder: 'desc',
      },
    };
  }

  private setTableOptions(): void {
    localStorage.removeItem('app-options');
    localStorage.removeItem('undefined');
    const tableOptions = this.appOptionsService.getOptions();
    localStorage.setItem('app-options', JSON.stringify(tableOptions));
  }
}
